import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { useTheme } from "../contexts/ThemeContext";
import { translate } from "../translations";

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { language, changeLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === `/${language}` || location.pathname === `/${language}/`;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (!element) return;
    setMenuOpen(false);
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className={`main-header ${scrolled ? "scrolled" : ""}`}>
      <div className="header-container">
        <div
          className="logo"
          onClick={() => {
            setMenuOpen(false);
            if (isHomePage) scrollTo("hero");
            else navigate(`/${language}`);
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              if (isHomePage) scrollTo("hero");
              else navigate(`/${language}`);
            }
          }}
        >
          <img
            src="/assets/ygalaad_icon_transparent.svg"
            alt="YGALAAD"
            className="logo-icon"
          />
          <span className="logo-text">
            <span className="logo-y">Y</span>GALA
            <span className="logo-accent">AD</span>
          </span>
        </div>
        <button
          className="burger-menu"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span className={`burger-bar ${menuOpen ? "open" : ""}`}></span>
          <span className={`burger-bar ${menuOpen ? "open" : ""}`}></span>
          <span className={`burger-bar ${menuOpen ? "open" : ""}`}></span>
        </button>
        <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
          {isHomePage ? (
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                scrollTo("hero");
              }}
            >
              {translate("home", language)}
            </a>
          ) : (
            <Link to={`/${language}`} onClick={() => setMenuOpen(false)}>
              {translate("home", language)}
            </Link>
          )}
          <a
            href="#about"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("about");
            }}
          >
            {translate("about", language)}
          </a>
          <a
            href="#products"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("products");
            }}
          >
            {translate("products", language)}
          </a>
          <a
            href="#news"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("news");
            }}
          >
            {translate("news", language)}
          </a>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              scrollTo("contact");
            }}
          >
            {translate("contact", language)}
          </a>
          <div className="header-controls">
            <button
              type="button"
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={theme === "dark" ? "Passer au thème clair" : "Passer au thème sombre"}
              title={theme === "dark" ? "Thème clair" : "Thème sombre"}
            >
              {theme === "dark" ? (
                <span className="theme-icon" aria-hidden="true">☀</span>
              ) : (
                <span className="theme-icon" aria-hidden="true">☽</span>
              )}
            </button>
            <div className="language-switcher">
              <button
                className={`lang-btn ${language === "fr" ? "active" : ""}`}
                onClick={() => changeLanguage("fr")}
                aria-label="Français"
              >
                FR
              </button>
              <button
                className={`lang-btn ${language === "en" ? "active" : ""}`}
                onClick={() => changeLanguage("en")}
                aria-label="English"
              >
                EN
              </button>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Header;
